// #MODULE - ColorSwatch.
// > Author: Balasubramanian Karthikesan
// > Create Date: Jan 17, 2017
// ##DESCRIPTION: This is the item view to display color swatch
import Mn from 'backbone.marionette';
import ColorSwatchTpl from './templates/partials/component-product-thumbnail/ColorSwatchTemplate.hbs';

export default Mn.ItemView.extend({
  template: ColorSwatchTpl,
  tagName: 'li',
  className: 'colorSwatch',
});
